module.exports = __webpack_public_path__ + "static/img/cxds.cf53955e.png";